import React from 'react';
import styles from './styles.module.css';

function LoadSpinner() {
  return (
    <div className={styles.ellipsis}><div></div><div></div><div></div><div></div></div>
  );
};

export default LoadSpinner;